/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { ActionIconProps, ActionIcon, Stack, Text, useMantineTheme } from '@mantine/core';
import { ReactNode, FC } from 'react';

interface Props extends ActionIconProps {
  children: ReactNode;
  active?: boolean;
  isVisible?: boolean;
  label: string;
  onClick?: () => void;
  reserveSpaceWhenHidden?: boolean;
  useDefaultWidth?: boolean;
}

const ActionIconWithText: FC<Props> = ({
  label,
  onClick,
  children,
  active = false,
  isVisible = true,
  reserveSpaceWhenHidden = true,
  useDefaultWidth = false,
  disabled,
  ...rest
}) => {
  const { colors, colorScheme } = useMantineTheme();

  return (
    <Stack
      aria-hidden={!isVisible}
      spacing={0}
      sx={{
        alignItems: 'center',
        display: !isVisible && !reserveSpaceWhenHidden ? 'none' : undefined,
        pointerEvents: isVisible ? undefined : 'none',
        visibility: isVisible ? 'visible' : 'hidden',
        width: useDefaultWidth ? '10%' : undefined,
      }}
    >
      <ActionIcon
        disabled={!isVisible || disabled}
        onClick={isVisible ? onClick : undefined}
        sx={{
          color: active ? colors.blue[colorScheme === 'dark' ? 1 : 4] : colorScheme === 'dark' ? '#E5E5E5' : '#1A1A1A',
        }}
        {...rest}
      >
        {children}
      </ActionIcon>
      <Text
        weight={active ? 'bolder' : 'normal'}
        // eslint-disable-next-line no-nested-ternary
        color={
          active
            ? colorScheme === 'dark'
              ? colors.blue[1]
              : colors.blue[4]
            : colorScheme === 'dark'
            ? '#E5E5E5'
            : '#1A1A1A'
        }
        size="xs"
      >
        {label}
      </Text>
    </Stack>
  );
};

export default ActionIconWithText;
